export const NOTIFICATION_CHANNEL_CATALOG = Object.freeze({
    'in-app': Object.freeze({
        id: 'in-app',
        group: 'notification',
        labelKey: 'communicationChannels.inApp',
        providerMode: 'core',
        supportsAttachments: false,
        supportsTemplates: true,
        supportsUserPreferences: true,
        templateFields: Object.freeze(['title', 'body', 'actionUrl']),
    }),
    email: Object.freeze({
        id: 'email',
        group: 'notification',
        labelKey: 'communicationChannels.email',
        providerMode: 'tenant-or-system',
        supportsAttachments: true,
        supportsTemplates: true,
        supportsUserPreferences: true,
        templateFields: Object.freeze(['subject', 'html', 'text']),
    }),
    sms: Object.freeze({
        id: 'sms',
        group: 'notification',
        labelKey: 'communicationChannels.sms',
        providerMode: 'tenant-or-system',
        supportsAttachments: false,
        supportsTemplates: true,
        supportsUserPreferences: true,
        templateFields: Object.freeze(['text']),
    }),
    push: Object.freeze({
        id: 'push',
        group: 'notification',
        labelKey: 'communicationChannels.push',
        providerMode: 'system',
        supportsAttachments: false,
        supportsTemplates: true,
        supportsUserPreferences: true,
        templateFields: Object.freeze(['title', 'body', 'actionUrl']),
    }),
});

export const INTEGRATION_CHANNEL_CATALOG = Object.freeze({
    webhook: Object.freeze({
        id: 'webhook',
        group: 'integration',
        labelKey: 'communicationChannels.webhook',
        providerMode: 'system',
        supportsAttachments: false,
        supportsTemplates: false,
        supportsUserPreferences: false,
    }),
});

export const NOTIFICATION_CHANNEL_IDS = Object.freeze(Object.keys(NOTIFICATION_CHANNEL_CATALOG));

/** Tenant policy and user preferences apply only to user-facing notification channels. */
export function isNotificationChannelPolicyGoverned(channel) {
    return Object.prototype.hasOwnProperty.call(NOTIFICATION_CHANNEL_CATALOG, channel);
}

export const TENANT_PROVIDER_CHANNELS = Object.freeze(
    NOTIFICATION_CHANNEL_IDS.filter((channel) => (
        NOTIFICATION_CHANNEL_CATALOG[channel].providerMode === 'tenant-or-system'
    )),
);

export function getNotificationChannelDefinition(channel) {
    return NOTIFICATION_CHANNEL_CATALOG[channel] || null;
}
